import Moment from 'moment';
// const HEARTBEAT_URL = "http://api.comet.heartbeat.june.se/";
// const HEARTBEAT_URL = "https://apicometheartbeat.azurewebsites.net/";
// const HEARTBEAT_URL = "https://june-heartbeat-staging.azurewebsites.net/";
const HEARTBEAT_URL = "https://apiheartbeat.june.se/";
// const JUNEAPI_URL = "https://june-api.june.se/api/";
const JUNEAPI_URL = "https://juneapi.junecomet.com/";

const REQUEST_HEADERS = { "Accept": "application/json" };

// http://api.comet.heartbeat.june.se/serviceLogs?serviceId=508&lastRun=2017-03-07

export const fetchAlerts = () => {
	return new Promise(function(resolve, reject) {
		fetch(`${HEARTBEAT_URL}services/alerts`, {
			headers: REQUEST_HEADERS
		})
		.then(processStatus)
		.then(data => { resolve(data); })
		.catch(error => { reject(error); });
	});
}

export const setAlertStatus = (url, status) => {
	return new Promise(function(resolve, reject) {
		url = `${HEARTBEAT_URL}${url}/setstatus/${status}`;
		fetch(url, {
			headers: { "Content-Type": "application/json" },
			method: "PUT",
		})
		.then(processStatus)
		.then(data => { resolve(data); })
		.catch(error => { reject(error, url); });
	});
}

export const setComment = (url, text) => {
	return new Promise(function(resolve, reject) {
		url = `${HEARTBEAT_URL}${url}/setmessage`;
		fetch(url, {
			headers: { "Content-Type": "application/json" },
			method: "PUT",
			body: JSON.stringify({ text, created: Moment().toISOString(true) })
		})
		.then(processStatus)
		.then(data => { resolve(data); })
		.catch(error => { reject(error, url); });
	});
}

export const snoozeService = (url, period) => {
	const duration = Moment.duration(period);
	const wakeup = Moment().add(duration).format("YYYYMMDDHHmm");
	return new Promise(function(resolve, reject) {
		url = `${HEARTBEAT_URL}${url}/snooze/${wakeup}`;
		fetch(url, {
			headers: { "Content-Type": "application/json" },
			method: "PUT"
		})
		.then(processStatus)
		.then(data => { resolve(data); })
		.catch(error => { reject(error, url); });
	});
}

export const fetchServices = (statusId) => { // 2 = On Hold, 1 = Active
	return new Promise(function(resolve, reject) {
		const status = statusId ? `?status=${statusId}` : "";
		fetch(`${HEARTBEAT_URL}services${status}`, {
			headers: REQUEST_HEADERS
		})
		.then(processStatus)
		.then(data => { resolve(data); })
		.catch(error => { reject(error); });
	});
}

export const fetchService = (serviceId) => {
	return new Promise(function(resolve, reject) {
		fetch(`${HEARTBEAT_URL}services/${serviceId}`, {
			headers: REQUEST_HEADERS
		})
		.then(processStatus)
		.then(data => { resolve(data); })
		.catch(error => { reject(error); });
	});
}

export const updateService = (service) => {
	return new Promise(function(resolve, reject) {
		fetch(`${HEARTBEAT_URL}services/${service.id}/update`, {
			headers: {
				...REQUEST_HEADERS,
				"Content-Type": "application/json",
			},
			method: "PUT",
			body: JSON.stringify(service)
		})
		.then(processStatus)
		.then(data => { resolve(data); })
		.catch(error => { reject(error); });
	});
}

export const fetchServiceNotifications = (serviceId) => {
	return new Promise(function(resolve, reject) {
		fetch(`${HEARTBEAT_URL}services/${serviceId}/notifications`, {
			headers: REQUEST_HEADERS
		})
		.then(processStatus)
		.then(data => { resolve(data); })
		.catch(error => { reject(error); });
	});
}

export const postNotificationAction = (serviceId, notificationId, action, name) => {
	return new Promise(function(resolve, reject) {
		fetch(`${HEARTBEAT_URL}services/${serviceId}/notifications/${notificationId}/notificationAction`, {
			headers: {
				...REQUEST_HEADERS,
				"Content-Type": "application/json",
			},
			method: "POST",
			body: JSON.stringify({
				action,
				name,
			}),
		})
		.then(processStatus)
		.then(data => { resolve(data); })
		.catch(error => { reject(error); });
	});
}

// LOGS
export const fetchLogs = (status, lastRun, serviceId) => {
	const pageSize = status === 0 ? 200 : 50;
	// console.log("Vilken typ är status? %o", status);
	const logstatus = status !== undefined ? `logstatus=${status}` : "";
	const showLogsFrom = lastRun ? `&lastRun=${lastRun}` : "";
	const service = serviceId ? `&serviceId=${serviceId}`: ""
	return new Promise(function(resolve, reject) {
		fetch(`${HEARTBEAT_URL}servicelogs?${logstatus}${service}${showLogsFrom}&pagesize=${pageSize}`, {
			headers: REQUEST_HEADERS
		})
		.then(processStatus)
		.then(data => { resolve(data); })
		.catch(error => { reject(error); });
	});
}

export const fetchLogsGrouped = (status, lastRun, itemsPerService = null) => {
	const pageSize = status === 0 ? 200 : 50;
	const showLogsFrom = lastRun ? `&lastRun=${lastRun}` : "";
	itemsPerService = itemsPerService ? `&CountPerService=${itemsPerService}` : "";

	return new Promise(function(resolve, reject) {
		fetch(`${HEARTBEAT_URL}serviceLogs/grouped?logstatus=${status}${showLogsFrom}&pagesize=${pageSize}${itemsPerService}`, {
			headers: REQUEST_HEADERS
		})
		.then(processStatus)
		.then(data => { resolve(data); })
		.catch(error => { reject(error); });
	});
}

export const fetchGiphyAnim = () => {
	return new Promise(function(resolve, reject) {
		fetch(`https://api.giphy.com/v1/gifs/random?api_key=NbC9gwLXerhb39QsxXGcf5wQMGEgQ1DY&rating=g&tag=thumbs-up`, {
			headers: REQUEST_HEADERS
		})
		.then(processStatus)
		.then(data => { resolve(data); })
		.catch(error => { reject(error); });
	});
}

export const fetchSentryIssues = () => {
	return new Promise(function(resolve, reject) {
		fetch(`${JUNEAPI_URL}sentry`)
			.then(processStatus)
			.then(data => { resolve(data); })
			.catch(error => { reject(error); });
	});
}

// TODO: Break out into a common function
var processStatus = response => {
	var data = null;
	switch(response.status) {
		case 200:
			data = response.json();
			return Promise.resolve(data);
		case 204:
			return Promise.resolve(data);
		default:
			// debugger;
			return Promise.reject(new Error(response.statusText))
	}
}


// WEBPACK FOOTER //
// ./src/api.js